import { TaskViewerAvatars } from "./TaskViewerAvatars";
import { useTaskRowViewerIds } from "./useTaskRowViewerIds";

interface TaskRowViewersProps {
    taskId: string;
    workspaceId: string;
}

/**
 * Who is viewing a task of the list. Hidden while a task body is open, which
 * shows its own viewers.
 */
export const TaskRowViewers = ({
    taskId,
    workspaceId,
}: TaskRowViewersProps) => {
    const userIds = useTaskRowViewerIds({ taskId, workspaceId });

    return <TaskViewerAvatars userIds={userIds} />;
};
